module.exports = __webpack_public_path__ + "static/media/instagram.792810b0.svg";